module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Attachment2-afe434056745aace87d79550b7a75e3c.svg";